




























import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import BButton from 'buefy/src/components/button/Button.vue';
import {Action, Getter, State} from 'vuex-class';
import BUpload from 'buefy/src/components/upload/Upload.vue'; // @ is an alias to /src
import BField from 'buefy/src/components/field/Field.vue'; // @ is an alias to /src
import BDropdown from 'buefy/src/components/dropdown/Dropdown.vue';
import BDropdownItem from 'buefy/src/components/dropdown/DropdownItem.vue';
import BSelect from 'buefy/src/components/select/Select.vue';

import {MAFUser} from '@/store/User/types';
import {LookupDistance, lookupIcon, LookupIcon} from '@/store/types';
import {User} from 'firebase'; // @ is an alias to /src

const namespace = 'userState';
@Component({
    components: {
        BDropdown,
        BDropdownItem,
        BSelect,
        BField,
        BButton,
        BUpload,
    },
})

export default class UploadModal extends Vue {
    @Prop() public readonly self!: MAFUser | undefined;
    @State('currentUser') public currentUser: User | undefined;
    @Action('updateUser', {namespace}) public updateUser: any;

    public upload: any;
    public isLoading: boolean;
    public updateUserWImg: MAFUser | undefined;
    constructor() {
        super();
        this.upload = null;
        this.isLoading = false;
        this.updateUserWImg = this.self;

    }

    public async submit() {
        this.isLoading = true;
        if (this.updateUserWImg) {
            if (!this.updateUserWImg.Reference) {
                const userDocumentRef = Vue.prototype.$firestore.collection('users').doc(this.updateUserWImg.uid);
                this.updateUserWImg.setDocumentReference(userDocumentRef);
            }
            const uploaded = await this.$storage.ref().child(`user-images/${this.updateUserWImg.uid}`).put(this.upload);
            const url = await this.$storage.ref().child(`user-images/${this.updateUserWImg.uid}`).getDownloadURL();
            this.updateUserWImg.avataarUrl = '';
            this.updateUserWImg.imageURL = url;
            this.updateUserWImg.userUploadedImage = true;
            try {
                await this.updateUser(this.updateUserWImg);
                } catch (e) {
            this.$snackbar.open({
                    message: 'Error saving user please try again.',
                    type: 'is-danger',
                    indefinite: true,
                });
        }
            this.isLoading = false;
            // @ts-ignore:
            this.$parent.close();
        }

    }
}
